import {HttpBackend, HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {Observable} from "rxjs";
import type {IWebAppConfig} from "../../../../common/app-config";

@Service()
export class WebApiService {
  // Using HttpBackend to avoid the auth interceptor,
  // which would try to add the token to the request that fetches the token.
  private readonly httpClient = new HttpClient(inject(HttpBackend));

  public getAppConfig(): Observable<IWebAppConfig> {
    return this.httpClient.get<IWebAppConfig>("/_web-api/config");
  }
}
